import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate, normalizeImageUrl } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function News() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/news").then(r => setItems(r.data)); }, []);
  const [featured, ...rest] = items;
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <div className="mb-12 max-w-3xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 mb-3">Berita</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-emerald-950">Berita & Informasi</h1>
      </div>
      {featured && (
        <Link to={`/berita/${featured.id}`} className="block mb-14 group">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="aspect-[16/10] rounded-2xl overflow-hidden">
              <img src={normalizeImageUrl(featured.photo_url)} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div>
              <div className="text-xs font-bold uppercase tracking-widest text-amber-600">{featured.category} · {fmtDate(featured.date)}</div>
              <h2 className="font-display text-2xl sm:text-3xl font-extrabold text-emerald-950 mt-3 leading-tight">{featured.title}</h2>
              <p className="text-slate-600 mt-4">{featured.excerpt}</p>
              <div className="mt-6 inline-flex items-center gap-1 text-sm font-bold text-emerald-800">Baca Selengkapnya <ArrowRight className="w-4 h-4" /></div>
            </div>
          </div>
        </Link>
      )}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {rest.map(n => (
          <Link key={n.id} to={`/berita/${n.id}`} data-testid={`news-${n.id}`} className="group">
            <div className="aspect-[16/10] rounded-xl overflow-hidden mb-4">
              <img src={normalizeImageUrl(n.photo_url)} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="text-xs font-bold uppercase tracking-widest text-amber-600">{n.category} · {fmtDate(n.date)}</div>
            <h3 className="font-display font-bold text-lg text-emerald-950 mt-2 leading-snug line-clamp-2">{n.title}</h3>
            <p className="text-sm text-slate-600 mt-2 line-clamp-2">{n.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
